<template>
  <div id="product">
    <Breadcrumb />
    <p class="sub-title prl70">Select Function</p>
    <div class="content middle collect mb50">
      <div class="cell">
        <!--  Start -->
        <div v-if="1">
          <div class="container font14 dflex" :class="{fcolumn: $store.getters.isVertical, frow: !$store.getters.isVertical}">
            <div class="row">
              <div class="col-xs-12 text-center mt30 inlineb mb30">
                <div class="inlineb p10 w100">
                  <div ref="printMe" class="inlineb">
                    <AlbaPanel v-if="type == 'alba'" />
                    <AriaPanel v-else-if="type == 'aria'" />
                    <AxesPanel v-else-if="type == 'axes'" />
                    <BlackJackPanel v-else-if="type == 'blackjack'" />
                  </div>
                </div>
              </div>
            </div>

            <div class="row prl70" :class="{pt100 : $store.getters.isVertical}">
              <div class="text-center" :class="'col-xs-' + 12 / $store.getters.divider">
                <div>
                  <p class="mt20 mb20" v-if="format != 'single'">{{ label1 }}</p>
                  <div v-if="leftLayoutSet.left" :class="{'col-xs-6': leftLayoutSet.right, 'col-xs-12': !leftLayoutSet.right}">
                    <p class="mt20 mb20" v-if="leftLayoutSet.right">LEFT BUTTON</p>
                    <el-radio
                      v-for="(item, key) in leftLayoutSet.left"
                      :key="key"
                      v-model="leftSideLeftButton"
                      :label="key"
                      :style="(isLayoutDisabled(key)) ? 'display:none' : ''"
                    >
                      <div class="mlr10 inlineb">
                        <div class="border inlineb svgb">
                          <i class="iconfont3" :class="item.img"></i>
                        </div>
                        <p class="name-f">
                          {{ item.label }}
                        </p>
                      </div>
                    </el-radio>
                  </div>
                  <div v-if="leftLayoutSet.right" class="col-xs-6">
                    <p class="mt20 mb20" >RIGHT BUTTON</p>
                    <el-radio
                      v-for="(item, key) in leftLayoutSet.right"
                      :key="key"
                      v-model="leftSideRightButton"
                      :label="key"
                      :style="(isLayoutDisabled(key)) ? 'display:none' : ''"
                    >
                      <div class="mlr10 inlineb">
                        <div class="border inlineb svgb">
                          <i class="iconfont3" :class="item.img"></i>
                        </div>
                        <p class="name-f">
                          {{ item.label }}
                        </p>
                      </div>
                    </el-radio>
                  </div>
                </div>
              </div>
              <div
                class="text-center" 
                :class="{['col-xs-' + 12 / $store.getters.divider] : true,
                'bdr-d' : !$store.getters.isVertical, 'bdrt-d' : $store.getters.isVertical}"
                v-if="format != 'single'"
              >
                <div>
                  <p class="mt20 mb20">
                    {{ label2 }}
                  </p>
                  <div v-if="rightLayoutSet.left" :class="{'col-xs-6': rightLayoutSet.right, 'col-xs-12': !rightLayoutSet.right}">
                    <p v-if="rightLayoutSet.right" class="mt20 mb20" >LEFT BUTTON</p>
                    <el-radio
                      v-for="(item, key) in rightLayoutSet.left"
                      :key="key"
                      v-model="rightSideLeftButton"
                      :label="key"
                      :style="(isLayoutDisabled(key)) ? 'display:none' : ''"
                    >
                      <div class="mlr10 inlineb">
                        <div class="border inlineb svgb">
                          <i class="iconfont3" :class="item.img"></i>
                        </div>
                        <p class="name-f">
                          {{ item.label }}
                        </p>
                      </div>
                    </el-radio>
                  </div>
                  <div v-if="rightLayoutSet.right" class="col-xs-6">
                    <p class="mt20 mb20" >RIGHT BUTTON</p>
                    <el-radio
                      v-for="(item, key) in rightLayoutSet.right"
                      :key="key"
                      v-model="rightSideRightButton"
                      :label="key"
                      :style="(isLayoutDisabled(key)) ? 'display:none' : ''"
                    >
                      <div class="mlr10 inlineb">
                        <div class="border inlineb svgb">
                          <i class="iconfont3" :class="item.img"></i>
                        </div>
                        <p class="name-f">
                          {{ item.label }}
                        </p>
                      </div>
                    </el-radio>
                  </div>
                </div>
              </div>
              <div
                class="text-center"
                :class="{['col-xs-' + 12 / $store.getters.divider] : true,
                'bdr-d' : !$store.getters.isVertical, 'bdrt-d' : $store.getters.isVertical}"
                v-if="$store.getters.isTriple"
              >
                <div>
                  <p class="mt20 mb20">{{ label3 }}</p>
                  <div v-if="tripleRightLayoutSet.left" :class="{'col-xs-6': tripleRightLayoutSet.right, 'col-xs-12': !tripleRightLayoutSet.right}">
                    <p v-if="tripleRightLayoutSet.right" class="mt20 mb20" >LEFT BUTTON</p>
                    <el-radio
                      v-for="(item, key) in tripleRightLayoutSet.left"
                      :key="key"
                      v-model="tripleRightSideLeftButton"
                      :label="key"
                      :style="(isLayoutDisabled(key)) ? 'display:none' : ''"
                    >
                      <div class="mlr10 inlineb">
                        <div class="border inlineb svgb">
                          <i class="iconfont3" :class="item.img"></i>
                        </div>
                        <p class="name-f">
                          {{ item.label }}
                        </p>
                      </div>
                    </el-radio>
                  </div>
                  <div v-if="tripleRightLayoutSet.right" class="col-xs-6">
                    <p class="mt20 mb20" >RIGHT BUTTON</p>
                    <el-radio
                      v-for="(item, key) in tripleRightLayoutSet.right"
                      :key="key"
                      v-model="tripleRightSideRightButton"
                      :label="key"
                      :style="(isLayoutDisabled(key)) ? 'display:none' : ''"
                    >
                      <div class="mlr10 inlineb">
                        <div class="border inlineb svgb">
                          <i class="iconfont3" :class="item.img"></i>
                        </div>
                        <p class="name-f">
                          {{ item.label }}
                        </p>
                      </div>
                    </el-radio>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="nav-footer white font16">
      <span class="white click inlineb w10" @click="restart()">
        <i class="iconfont3 icon-reset"></i> RESTART
      </span>
      <span class="white click inlineb w10" @click="back()">
        <i class="iconfont3 icon-back"></i> BACK
      </span>
      <span class="orange click inlineb w10" @click="next()">
        NEXT <i class="iconfont3 icon-next"></i>
      </span>
    </div>
  </div>
</template>
<style scoped>
.el-radio {
  width: 100px;
}
</style>
<script>
import "@/assets/css/project.css";
import Breadcrumb from "./Panel/Breadcrumb";
import AlbaPanel from "./Panel/AlbaPanel";
import AriaPanel from "./Panel/AriaPanel";
import AxesPanel from "./Panel/AxesPanel";
import BlackJackPanel from "./Panel/BlackJackPanel";
import artworkToProductMixin from "../../mixins/artworkToProductMixin";

export default {
  name: "s2",
  components: {
    Breadcrumb,
    AlbaPanel,
    AriaPanel,
    AxesPanel,
    BlackJackPanel
  },
  mixins: [artworkToProductMixin],
  data() {
    return {
      type: null,
      format: null,
      layoutSet: {
        single: {
          alba: {
            left : {
              A: { label: "A", img: "icon-a_alba" },
              B: { label: "B", img: "icon-b_alba" },
              D: { label: "D", img: "icon-d_alba" },
              M1: { label: "M1", img: "icon-alba-m" },
            },
            right: {
              A: { label: "A", img: "icon-a_alba" },
              B: { label: "B", img: "icon-b_alba" },
              D: { label: "D", img: "icon-d_alba" },
            }
          },
          aria: {
            left: {
              L9: { label: "L9", img: "icon-aria" },
              L12: { label: "L12", img: "icon-aria1" },
              M1: { label: "M1", img: "icon-aria-m1" },
            },
          },
          axes: {
            left: {
              CR: { label: "CH NO RFID", img: "icon-axes-ch" },
              CH: { label: "CH WITH RFID", img: "icon-axes-ch" },
              DR: { label: "DR", img: "icon-axes-dr" },
              KN: { label: "KN", img: "icon-axes-nk" },
              N34: { label: "N3", img: "icon-axes-sf" },
              N35: { label: "N3", img: "icon-axes-sf-5" },
            },
          },
          blackjack: {
            left : {
              A: { label: "A", img: "icon-a_" + this.$store.state.artwork.buttonFormat },
              B: { label: "B", img: "icon-b_" + this.$store.state.artwork.buttonFormat },
              C: { label: "C", img: "icon-c_" + this.$store.state.artwork.buttonFormat },
              D: { label: "D", img: "icon-d_" + this.$store.state.artwork.buttonFormat },
              M1: { label: "M1", img: "icon-m1_" + this.$store.state.artwork.buttonFormat },
            },
            right: {
              A: { label: "A", img: "icon-a_" + this.$store.state.artwork.buttonFormat },
              B: { label: "B", img: "icon-b_" + this.$store.state.artwork.buttonFormat },
              C: { label: "C", img: "icon-c_" + this.$store.state.artwork.buttonFormat },
              D: { label: "D", img: "icon-d_" + this.$store.state.artwork.buttonFormat },
            }
          },
        },
        double: {
          alba: {
            left : {
              A: { label: "A", img: "icon-a_alba" },
              B: { label: "B", img: "icon-b_alba" },
              D: { label: "D", img: "icon-d_alba" },
              M1: { label: "M1", img: "icon-alba-m" },
              SK: { label: "SK", img: "icon-socket" },
            },
            right: {
              A: { label: "A", img: "icon-a_alba" },
              B: { label: "B", img: "icon-b_alba" },
              D: { label: "D", img: "icon-d_alba" },
            }
          },
          aria: {
            left: {
              L9: { label: "L9", img: "icon-aria" },
              L12: { label: "L12", img: "icon-aria1" },
              M1: { label: "M1", img: "icon-aria-m1" },
              SK: { label: "SK", img: "icon-socket" },
            },
          },
          axes: {
            left: {
              DR: { label: "DR", img: "icon-axes-dr" },
              KN: { label: "KN", img: "icon-axes-nk" },
              N34: { label: "N3", img: "icon-axes-sf" },
              N35: { label: "N3", img: "icon-axes-sf-5" },
            }
          },
          blackjack: {
            left : {
              A: { label: "A", img: "icon-a_" + this.$store.state.artwork.buttonFormat },
              B: { label: "B", img: "icon-b_" + this.$store.state.artwork.buttonFormat },
              C: { label: "C", img: "icon-c_" + this.$store.state.artwork.buttonFormat },
              D: { label: "D", img: "icon-d_" + this.$store.state.artwork.buttonFormat },
              M1: { label: "M1", img: "icon-m1_" + this.$store.state.artwork.buttonFormat },
              SK: { label: "SK", img: "icon-socket" },
            },
            right: {
              A: { label: "A", img: "icon-a_" + this.$store.state.artwork.buttonFormat },
              B: { label: "B", img: "icon-b_" + this.$store.state.artwork.buttonFormat },
              C: { label: "C", img: "icon-c_" + this.$store.state.artwork.buttonFormat },
              D: { label: "D", img: "icon-d_" + this.$store.state.artwork.buttonFormat },
            }
          },
        },
        vdouble: {
          alba: {
            left : {
              A: { label: "A", img: "icon-a_alba" },
              B: { label: "B", img: "icon-b_alba" },
              D: { label: "D", img: "icon-d_alba" },
              M1: { label: "M1", img: "icon-alba-m" },
              SK: { label: "SK", img: "icon-socket" },
            },
            right: {
              A: { label: "A", img: "icon-a_alba" },
              B: { label: "B", img: "icon-b_alba" },
              D: { label: "D", img: "icon-d_alba" },
            }
          },
          aria: {
            left : {
              L9: { label: "L9", img: "icon-aria" },
              L12: { label: "L12", img: "icon-aria1" },
              M1: { label: "M1", img: "icon-aria-m1" },
              SK: { label: "SK", img: "icon-socket" },
            }
          },
          axes: {
            left: {
              DR: { label: "DR", img: "icon-axes-dr" },
              KN: { label: "KN", img: "icon-axes-nk" },
              N34: { label: "N3", img: "icon-axes-sf" },
              N35: { label: "N3", img: "icon-axes-sf-5" },
            }
          },
          blackjack: {
            left : {
              A: { label: "A", img: "icon-a_" + this.$store.state.artwork.buttonFormat },
              B: { label: "B", img: "icon-b_" + this.$store.state.artwork.buttonFormat },
              C: { label: "C", img: "icon-c_" + this.$store.state.artwork.buttonFormat },
              D: { label: "D", img: "icon-d_" + this.$store.state.artwork.buttonFormat },
              M1: { label: "M1", img: "icon-m1_" + this.$store.state.artwork.buttonFormat },
              SK: { label: "SK", img: "icon-socket" },
            },
            right: {
              A: { label: "A", img: "icon-a_" + this.$store.state.artwork.buttonFormat },
              B: { label: "B", img: "icon-b_" + this.$store.state.artwork.buttonFormat },
              C: { label: "C", img: "icon-c_" + this.$store.state.artwork.buttonFormat },
              D: { label: "D", img: "icon-d_" + this.$store.state.artwork.buttonFormat },
            }
          },
        },
        triple: {
          alba: {
            left : {
              A: { label: "A", img: "icon-a_alba" },
              B: { label: "B", img: "icon-b_alba" },
              D: { label: "D", img: "icon-d_alba" },
              SK: { label: "SK", img: "icon-socket" },
            },
            right: {
              A: { label: "A", img: "icon-a_alba" },
              B: { label: "B", img: "icon-b_alba" },
              D: { label: "D", img: "icon-d_alba" },
            }
          },
          aria: {
            left : {
              L9: { label: "L9", img: "icon-aria" },
              L12: { label: "L12", img: "icon-aria1" },
              SK: { label: "SK", img: "icon-socket" },
            }
          },
          /* axes: {
            left: {
              DR: { label: "DR", img: "icon-axes-dr" },
              KN: { label: "KN", img: "icon-axes-nk" },
              N34: { label: "N3", img: "icon-axes-sf" },
              N35: { label: "N3", img: "icon-axes-sf-5" },
            }
          }, */
          blackjack: {
            left : {
              A: { label: "A", img: "icon-a_" + this.$store.state.artwork.buttonFormat },
              B: { label: "B", img: "icon-b_" + this.$store.state.artwork.buttonFormat },
              C: { label: "C", img: "icon-c_" + this.$store.state.artwork.buttonFormat },
              D: { label: "D", img: "icon-d_" + this.$store.state.artwork.buttonFormat },
              M1: { label: "M1", img: "icon-m1_" + this.$store.state.artwork.buttonFormat },
              SK: { label: "SK", img: "icon-socket" },
            },
            right: {
              A: { label: "A", img: "icon-a_" + this.$store.state.artwork.buttonFormat },
              B: { label: "B", img: "icon-b_" + this.$store.state.artwork.buttonFormat },
              C: { label: "C", img: "icon-c_" + this.$store.state.artwork.buttonFormat },
              D: { label: "D", img: "icon-d_" + this.$store.state.artwork.buttonFormat },
            }
          },
        },
        vtriple: {
          alba: {
            left : {
              A: { label: "A", img: "icon-a_alba" },
              B: { label: "B", img: "icon-b_alba" },
              D: { label: "D", img: "icon-d_alba" },
              SK: { label: "SK", img: "icon-socket" },
            },
            right: {
              A: { label: "A", img: "icon-a_alba" },
              B: { label: "B", img: "icon-b_alba" },
              D: { label: "D", img: "icon-d_alba" },
            }
          },
          aria: {
            left : {
              L9: { label: "L9", img: "icon-aria" },
              L12: { label: "L12", img: "icon-aria1" },
              SK: { label: "SK", img: "icon-socket" },
            },
          },
          /* axes: {
            left: {
              DR: { label: "DR", img: "icon-axes-dr" },
              KN: { label: "KN", img: "icon-axes-nk" },
              N34: { label: "N3", img: "icon-axes-sf" },
              N35: { label: "N3", img: "icon-axes-sf-5" },
            }
          }, */
          blackjack: {
            left : {
              A: { label: "A", img: "icon-a_" + this.$store.state.artwork.buttonFormat },
              B: { label: "B", img: "icon-b_" + this.$store.state.artwork.buttonFormat },
              C: { label: "C", img: "icon-c_" + this.$store.state.artwork.buttonFormat },
              D: { label: "D", img: "icon-d_" + this.$store.state.artwork.buttonFormat },
              M1: { label: "M1", img: "icon-m1_" + this.$store.state.artwork.buttonFormat },
              SK: { label: "SK", img: "icon-socket" },
            },
            right: {
              A: { label: "A", img: "icon-a_" + this.$store.state.artwork.buttonFormat },
              B: { label: "B", img: "icon-b_" + this.$store.state.artwork.buttonFormat },
              C: { label: "C", img: "icon-c_" + this.$store.state.artwork.buttonFormat },
              D: { label: "D", img: "icon-d_" + this.$store.state.artwork.buttonFormat },
            }
          },
        },
      },
    };
  },

  methods: {
    isLayoutDisabled() {
      return false;
      /* let privileges = [];
      if (this.$store.state.user) {
        privileges = this.$store.state.user.checkedConfiguratorPermissions;
      }
      if (key == 'TT') {
        if (privileges && privileges.length > 0 && privileges.includes('AXES/TT')) {
          return false
        }
        return true;
      }
      return false; */
    },
    restart() {
      this.$confirm("Are you sure you want to restart?", "Warning", {
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        type: "warning",
      }).then(() => {
        this.$router.push({ path: "/collection" });
      });
    },

    next() {
      this.$store.commit("getProductCode");
      //Go to next page
      this.$router.push({ path: "/collection/style/" + this.routeParamArtworkId});
    },
    back() {
      this.$store.commit("getProductCode");
      if (this.type == 'blackjack') {
        this.$router.push({ path: "/collection/button-format/" + this.routeParamArtworkId });
      } else {
        this.$router.push({ path: "/collection/format/" + this.routeParamArtworkId });
      }
    },
  },

  created: function () {
    if (!this.$store.state.artwork.type) {
      alert("Please go to the start page");
      this.$router.push({ path: "/collection/" });
    }
    this.$parent.headerB();
    this.$parent.headerNoBg();
    this.$parent.footerB();
    this.$parent.footerW();
    this.$store.state.current_step = 4;
    this.type = this.$store.state.artwork.type || "alba";
    this.format = this.$store.state.artwork.format || "single";
  },
  computed: {
    leftSideLeftButton: {
      get() {
        return this.$store.state.artwork.leftSideLeftButton;
      },
      set(newVal) {
        this.$store.state.artwork.leftSideLeftButton = newVal;
        
        if (this.leftLayoutSet.right) {
          if (this.leftLayoutSet.right[this.leftSideRightButton] === undefined) {
            this.leftSideRightButton = Object.keys(this.leftLayoutSet.right)[0] || null;
          }
          let l = newVal + this.leftSideRightButton;
          this.layout = this.$store.state.mapLayout[l] || l;
        } else {
          this.leftSideRightButton = null;
          this.layout = newVal;
        }
      }
    },
    leftSideRightButton: {
      get() {
        return this.$store.state.artwork.leftSideRightButton;
      },
      set(newVal) {
        this.$store.state.artwork.leftSideRightButton = newVal;
        if (newVal == null) {
         return;
        }
        let l = this.leftSideLeftButton + newVal;
        this.layout = this.$store.state.mapLayout[l] || l;
      },
    },
    rightSideLeftButton: {
      get() {
        return this.$store.state.artwork.rightSideLeftButton;
      },
      set(newVal) {
        this.$store.state.artwork.rightSideLeftButton = newVal;
        if (this.rightLayoutSet.right) {
          if (this.rightLayoutSet.right[this.rightSideRightButton] === undefined) {
            this.rightSideRightButton = Object.keys(this.rightLayoutSet.right)[0] || null;
          }
          let l = newVal + this.rightSideRightButton;
          this.rightLayout = this.$store.state.mapLayout[l] || l;
        } else {
          this.rightSideRightButton = null;
          this.rightLayout = newVal;
        }
      }
    },
    rightSideRightButton: {
      get() {
        return this.$store.state.artwork.rightSideRightButton;
      },
      set(newVal) {
        this.$store.state.artwork.rightSideRightButton = newVal;
        if (newVal == null) {
         return;
        }
        let l = this.rightSideLeftButton + newVal;
        this.rightLayout = this.$store.state.mapLayout[l] || l;
      },
    },
    tripleRightSideLeftButton: {
      get() {
        return this.$store.state.artwork.tripleRightSideLeftButton;
      },
      set(newVal) {
        this.$store.state.artwork.tripleRightSideLeftButton = newVal;
        if (this.tripleRightLayoutSet.right) {
          if (this.tripleRightLayoutSet.right[this.tripleRightSideRightButton] === undefined) {
            this.tripleRightSideRightButton = Object.keys(this.tripleRightLayoutSet.right)[0] || null;
          }
          let l = newVal + this.tripleRightSideRightButton;
          this.tripleRightLayout = this.$store.state.mapLayout[l] || l;
        } else {
          this.tripleRightSideRightButton = null;
          this.tripleRightLayout = newVal;
        }
      }
    },
    tripleRightSideRightButton: {
      get() {
        return this.$store.state.artwork.tripleRightSideRightButton;
      },
      set(newVal) {
        this.$store.state.artwork.tripleRightSideRightButton = newVal;
        if (newVal == null) {
         return;
        }
        let l = this.tripleRightSideLeftButton + newVal;
        this.tripleRightLayout = this.$store.state.mapLayout[l] || l;
      },
    },
    label1() {
      return (this.format == 'vdouble') ? 'TOP SIDE' : 'LEFT SIDE';
    },
    label2() {
      if (this.format == 'double') {
        return 'RIGHT SIDE';
      } else if (this.$store.getters.isTriple) {
        return 'CENTER';
      } else if (this.format == 'vdouble') {
        return 'BOTTOM SIDE';
      }
      return '';
    },
    label3(){
      if (this.$store.getters.isVertical) {
        return 'BOTTOM SIDE';
      }
      return 'RIGHT SIDE';
    },
    leftLayoutSet() {
      var set = JSON.parse(JSON.stringify(this.layoutSet[this.format][this.type])); 
      
      if ((this.type == "alba" || this.type == "blackjack") && ['M1', 'SK'].includes(this.leftSideLeftButton)) {
        delete set.right;
      } else if (this.type == "blackjack") {
        if (this.leftSideLeftButton == "D") {
          delete set.right["A"];
          delete set.right["B"];
          delete set.right["C"];
        } else if (this.leftSideLeftButton == "A") {
          delete set.right["C"];
          delete set.right["D"];
        } else if (this.leftSideLeftButton == "B") {
          delete set.right["D"];
        } else if (this.leftSideLeftButton == "C") {
          delete set.right["A"];
          delete set.right["D"];
        }
      } else if (this.type == "axes") {
        if (this.$store.getters.isDouble) {
          if (["N34", "N35"].includes(this.rightLayout)) {
            delete set.left["N34"];
            delete set.left["N35"];
          } else {
            delete set.left[this.rightLayout];
          }
        } else if (this.$store.getters.isTriple) {
            return { left : { SK : set.left["SK"] } };
        }
      }
      
      if (this.$store.getters.isTriple) {
        return set;
      } else if (this.$store.getters.isDouble) {
         if (this.rightLayout == "SK") {
            delete set.left["SK"];
        } else if (this.rightLayout == "M1" && this.type == "aria") {
          delete set.left["M1"];
        }
      }

      return set;
    },
    rightLayoutSet() {
      var set = JSON.parse(JSON.stringify(this.layoutSet[this.format][this.type])); 

      if (this.$store.getters.isTriple) {
          return { left : { SK : set.left["SK"]  }};
      }

      if ((this.type == "alba" || this.type == "blackjack") && ['M1', 'SK'].includes(this.rightSideLeftButton)) {
        delete set.right;
      } else if (this.type == "blackjack") {
        if (this.rightSideLeftButton == "D") {
          delete set.right["A"];
          delete set.right["B"];
          delete set.right["C"];
        } else if (this.rightSideLeftButton == "A") {
          delete set.right["C"];
          delete set.right["D"];
        } else if (this.rightSideLeftButton == "B") {
          delete set.right["D"];
        } else if (this.rightSideLeftButton == "C") {
          delete set.right["A"];
          delete set.right["D"];
        }
      } else if (this.type == "axes") {
        if (["N34", "N35"].includes(this.layout)) {
          delete set.left["N34"];
          delete set.left["N35"];
        }  else {
          delete set.left[this.layout];
        }
      } else  {
        if (this.layout == "SK") {
          delete set.left["SK"];
        } else if (this.layout == "M1" && this.type == "aria") {
          delete set.left["M1"];
        }
      }
      
      return set;
    },
    tripleRightLayoutSet() {
      var set = JSON.parse(JSON.stringify(this.layoutSet[this.format][this.type])); 

      if (this.$store.getters.isTriple){

        if (this.type == "blackjack") {
          if (this.tripleRightSideLeftButton == "D") {
            delete set.right["A"];
            delete set.right["B"];
            delete set.right["C"];
          } else if (this.tripleRightSideLeftButton == "A") {
            delete set.right["C"];
            delete set.right["D"];
          } else if (this.tripleRightSideLeftButton == "B") {
            delete set.right["D"];
          } else if (this.tripleRightSideLeftButton == "C") {
            delete set.right["A"];
            delete set.right["D"];
          } else if (this.tripleRightSideLeftButton == "M1") {
            delete set.right;
          }
        } 

        if (this.layout == "SK") {
          delete set.left["SK"];
        } else {
          return { left : { SK : set.left["SK"]  }};
        }
      } 
      
      return set;
    },
    layout: {
      get: function () {
        return this.$store.state.artwork.layout;
      },
      set: function (newValue) {
        this.$store.state.artwork.layout = newValue;
        if (newValue == "SK") {
          this.$store.state.artwork.layoutStyle = "socket";
        } else {
          this.$store.state.artwork.layoutStyle = "iconOnly";
        }
        if (newValue == "M1" && this.type == "aria") {
          this.$store.state.artwork.layoutAriaM1TempIcons = true;
        }
        this.$store.commit("getContent");
      },
    },
    rightLayout: {
      get: function () {
        return this.$store.state.artwork.rightLayout;
      },
      set: function (newValue) {
        this.$store.state.artwork.rightLayout = newValue;
        if (newValue == "SK") {
          this.$store.state.artwork.rightLayoutStyle = "socket";
        } else {
          this.$store.state.artwork.rightLayoutStyle = "iconOnly";
        }
        if (newValue == "M1" && this.type == "aria") {
          this.$store.state.artwork.rightLayoutAriaM1TempIcons = true;
        }
        this.$store.commit("getRightContent");
      },
    },
    tripleRightLayout: {
      get: function () {
        return this.$store.state.artwork.tripleRightLayout;
      },
      set: function (newValue) {
        this.$store.state.artwork.tripleRightLayout = newValue;
        if (newValue == "SK") {
          this.$store.state.artwork.tripleRightLayoutStyle = "socket";
        } else {
          this.$store.state.artwork.tripleRightLayoutStyle = "iconOnly";
        }
        if (newValue == "M1" && this.type == "aria") {
          this.$store.state.artwork.tripleRightLayoutAriaM1TempIcons = true;
        }
        this.$store.commit("getTripleRightContent");
      },
    },
    
  },
  watch: {
    layout(newVal) {
      if (this.$store.getters.isTriple) {
        if (newVal == "SK") {
          this.tripleRightSideLeftButton = Object.keys(this.tripleRightLayoutSet.left)[0];
        } else {
          this.tripleRightLayout = "SK";
          this.tripleRightSideLeftButton = "SK";
        }
      } 
    }
  }
};
</script>

<style lang="css" scoped>
.nav-footer {
  border-top: 1px solid #ccc;
}
</style>
